import classNames from 'classnames';
import { PlusIcon } from '../../../images';
import styles from './action-button.module.scss';
import { getLang } from 'shared/store/selectors/lang.selector';
import { useSelector } from 'react-redux';
import { Lang } from 'shared/constants';
import { IconButton } from 'src/components/design-system';

export function ActionButton({
  onClick = () => {},
  labelKey = 'ADD_SECTION',
  className = {},
  iconClassName = {},
  disabled = false,
  icon: Icon = PlusIcon,
  labelText = null,
  positionAbsolute = true,
  renderIcon = null,
  id,
}) {
  const lang = useSelector(getLang('ACTION_BUTTON_TOOLTIPS'));
  const label = labelText || lang[labelKey] || Lang.ACTION_BUTTON_TOOLTIPS[labelKey] || '';

  return (
    <IconButton
      id={id}
      tooltipProps={{
        placement: 'topRight',
      }}
      label={label}
      className={classNames(styles.createItem, className, {
        [styles.positionAbsolute]: positionAbsolute,
      })}
      disabled={disabled}
      onClick={onClick}
      data-testid="add-section-button"
    >
      {renderIcon ? renderIcon : <Icon className={classNames(styles.icon, iconClassName)} />}
    </IconButton>
  );
}
